import actions from '../../actionTypes';

export default action => {
  return {
    type: actions.REMOVE_ACTION,
    action
  };
};



// WEBPACK FOOTER //
// ./src/reducers/trigger-actions/actions/removeAction.js